import { IShiftFormCustomField } from 'modals/ShiftModal/src/components/ShiftCustomFields/ShiftCustomFields.types';
import { FormValuesType, isArray } from 'types/common.types';
import { CustomField } from 'types/graphql';

export function composeCustomFieldsForPayload(
  values: FormValuesType,
  communityCustomFields: CustomField[],
): IShiftFormCustomField[] {
  const customFieldsPayload = Object.keys(values).reduce((acc: IShiftFormCustomField[], key) => {
    const communityCustomField = communityCustomFields.find(
      (customField) => customField.name === key,
    );
    const shiftCustomFieldValue = values[key];
    if (
      communityCustomField &&
      shiftCustomFieldValue &&
      typeof shiftCustomFieldValue === 'string'
    ) {
      acc = acc.concat([
        {
          custom_field_id: communityCustomField.id,
          name: communityCustomField.name,
          value: shiftCustomFieldValue,
        },
      ]);
    } else if (communityCustomField && shiftCustomFieldValue && isArray(shiftCustomFieldValue)) {
      if (shiftCustomFieldValue[0]) {
        acc = acc.concat([
          {
            custom_field_id: communityCustomField.id,
            name: communityCustomField.name,
            value: shiftCustomFieldValue[0],
          },
        ]);
      }
    }
    return acc;
  }, []);
  return customFieldsPayload;
}
